-- | This module acts as an interface to the employer modal which is
-- | implemented in livewire and must be called from javascript.
module Widgets.EmployerModal where

import Common

import API.SelEmployer (EmployerID)
import API.Types (ID)
import Data.Nullable (Nullable, toMaybe, toNullable)
import Effect.Aff.Compat (EffectFnAff, fromEffectFnAff)
import GraphQL.Type (innerId, typedId)

employerCreateModal :: Maybe EmployerID -> Widget HTML (Maybe EmployerID)
employerCreateModal id = map (typedId <$> _) $ map toMaybe $ affAction $ fromEffectFnAff $
    runEmployerModal $ toNullable $ map innerId id

foreign import runEmployerModal :: Nullable ID -> EffectFnAff (Nullable ID)
